import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2FAF8E0B-5AB4-4914-A0A1-CECFFAF85427
 * name chart-line-variant
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-line-variant.svg
 * tags
 * - Math 
 */
export const ChartLineVariantIcon = createSvgIcon(<><path d="M3.5,18.5L9.5,12.5L13.5,16.5L22,6.92L20.59,5.5L13.5,13.5L9.5,9.5L2,17L3.5,18.5Z" /></>, 'ChartLineVariantIcon');
export default ChartLineVariantIcon